import Layout from "../components/Layout";
import AddEditVehicle from "../components/AddEditVehicle";
import SEO from "../components/SEO";

export default function Add() {
  return (
    <>
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/vehicle/vender`}
        title="Vender Auto"
        siteTitle="Movi Autos"
      />
      <AddEditVehicle />
    </>
  );
}

Add.auth = {
  role: "user", // RESEARCH HOW TO GET THIS FROM THE USE SESSION (for admin only routes?)
  // loading: <AdminLoadingSkeleton />,
  unauthorized: "/auth/signin",
};

Add.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
